import PropTypes from 'prop-types';
import React from 'react';

import LearningSpaceTasksType from '../../../../model/LearningSpaceTasksType';
import useEnumerableModel from '../../../data/hooks/useEnumerableModel';
import itemIdValue from '../../../itemIdValue';
import useLabel from '../../utils/Translations/useLabel';
import MultiselectFilter from './MultiselectFilter';

const LearningSpaceTasksTypeSelector = ({ title, ...props }) => {
  const { options } = useEnumerableModel(LearningSpaceTasksType);

  const _title = useLabel('Task', title);

  return (
    <MultiselectFilter
      itemId={itemIdValue}
      options={options}
      title={_title}
      {...props}
    />
  );
};

LearningSpaceTasksTypeSelector.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.oneOf(LearningSpaceTasksType.BasicProps)),
    PropTypes.string,
  ]),
  onChange: PropTypes.func,
  title: PropTypes.string,
};

LearningSpaceTasksTypeSelector.defaultProps = {
  value: null,
  onChange: null,
  title: null,
};

export default LearningSpaceTasksTypeSelector;
